import request from '../request'

const authApi = {
    login: (payload) => request.post(`/clients/web/login`, payload),
    logout: () => request.delete(`/logout`),
    register: (payload) => request.post(`/users/shop-register`, payload),
    forgotPassword: (payload) => request.post('/password/forgot', payload),
    confirmPassword: (id,payload) => request.patch(`users/${id}/confirm-password`,payload),
    verifyCapcha: (query) => request.post(`/verify-capcha${query}`),

}

export default authApi;